import { approvalStatusQualityMapper } from 'modules/campaigns/lib/constants';
import { WhatsAppContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { TemplateDetailsBlock } from './EditableHeader.styled';

export const SubHeaderApproval = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { metaApprovalStatus, qualityRating } =
    liveTemplate.mediumData as WhatsAppContentDefinition;

  return metaApprovalStatus ? (
    <TemplateDetailsBlock>
      {approvalStatusQualityMapper(metaApprovalStatus, qualityRating)}
    </TemplateDetailsBlock>
  ) : null;
};
